import React from 'react';
import { goOut } from '../../../../helpers/AuthenticationHelper';
import CloseIcon from '../../../common/icons/closeIcon';

export const goOutGroup = {
  route: goOut,
  icon: <CloseIcon size="30px" />,
  title: 'Cerrar Sesión',
  id: 'closeSessionSection',
};
